import React from 'react';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import { AdminComplianceList } from '../Admin/ComplianceManagement/AdminComplianceList';
import SearchCompliance from '../Admin/ComplianceManagement/SearchCompliance';
import { LicenseManager } from 'ag-grid-enterprise';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const ComplianceManagementTab = () => {
    const { translation:t } = System;
    const { adminConsoleTab: { MainTab } } = Constants
    LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-056206}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Avnet,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{8_April_2025}____[v3]_[0102]_MTc0NDA2NjgwMDAwMA==cf84f96f564ac2682d3fb4562a2ca4cb");
    return (
        <>
            <div className='adminconsole-container orderadmin-container'>
                <AdminConsoleHeader title={t('EXPORTCOMPLIANCEVIEWER')} tab={MainTab} />
                <div>
                    <div >
                        <SearchCompliance />
                    </div>
                    <ObjCommonFilterSelection />
                    <div>
                        <AdminComplianceList />
                    </div>
                </div>

            </div>
        </>
    );
}

export default ComplianceManagementTab;